import React from 'react';

function Thirteen() {
    return (
        <div className="blog-post">
            <h1>Focus Group Script for Our Language-Learning Network</h1>
            <small>04-27-2026</small>

            <h2>What's The Purpose of this Focus Group?</h2>
            <p>
                Hi Spanish 102 students. The purpose of this project is to create a social network that allows students
                 who are learning foreign languages to effectively study and review. It creates a more interactive mode
                 of communication, meant for educational purposes. Today you'll be testing out our <a href='https://138-197-42-211.sslip.io/cs480/login' target="_blank" rel="noopener noreferrer">site</a>.
            </p>
            <br />
            <h2>Login and Test Our Network</h2>
            <ul>
                <li>
                    Login to the website using one of these two accounts:<br />
                    USER 1: test123<br />
                    USER2: test234<br />
                    Password for both is 1234
                </li>
                <li>
                    Join a section and begin creating posts using the text, audio or trivia features. You can also reply to other users
                     in the chat.<br />

                    When testing the trivia feature, there's an optional text box for a trivia prompt. An example of this would include
                     "Translate all of the following sentences" as the title, with each prompt being a sentence for the user to translate.
                </li>
                <li>
                    Once posts have been made, try out the translation, edit, and delete features. Begin brainstorming about
                     which features you like, and which features you think are missing.
                </li>
            </ul>
            <br />
            <h2>Questions to Think About</h2>
            <ul>
                <li>
                    Name one thing you liked and one thing you disliked about the app.
                </li>
                <li>
                    On a scale of 1-10, how well do you think this website supports active learning of a new language?
                     Explain your score.
                </li>
                <li>
                    Was there any part of the websie that was confusing to use?
                </li>
                <li>
                    What's one thing you've seen in another app that you'd want to steal for this?
                </li>
            </ul>
        </div>
    );
}

export default Thirteen;
